import { useQuery } from "@apollo/client";
import { MONTAGE_PROGRESS } from "MVVM/GraphQL/pulse";
import type {
  MontageProgressQueryData,
  MontageProgressQueryVars,
  MontageProgress,
} from "MVVM/Components/ClipStatus/@types";
import { MontageProgressState } from "MVVM/Components/ClipStatus/@types";

const MONTAGE_POLL_INTERVAL = 5000;

const TERMINAL_MONTAGE_STATES: ReadonlySet<MontageProgressState> = new Set([
  MontageProgressState.COMPLETED,
  MontageProgressState.ERROR,
]);

export const useMontageProgress = (
  montageId: string | undefined,
): { montage: MontageProgress | null; loading: boolean } => {
  const { data, loading, startPolling, stopPolling } = useQuery<
    MontageProgressQueryData,
    MontageProgressQueryVars
  >(MONTAGE_PROGRESS, {
    variables: { montageId: montageId! },
    fetchPolicy: "cache-and-network",
    skip: !montageId,
    notifyOnNetworkStatusChange: true,
    onCompleted: (result) => {
      const mp = result?.montageProgress;
      if (!mp || TERMINAL_MONTAGE_STATES.has(mp.state)) {
        stopPolling();
      } else {
        startPolling(MONTAGE_POLL_INTERVAL);
      }
    },
    onError: () => {
      stopPolling();
    },
  });

  return {
    montage: data?.montageProgress ?? null,
    loading,
  };
};
